<div [ngClass]="{
  'success-dialog': !data.secondaryButtonText && data.type !== 'success',
  'success-toast': data.type === 'success' && !data.secondaryButtonText,
  'confirmation-dialog': !!data.secondaryButtonText
}">

  <!-- Non-confirmation dialogs: standard layout -->
  <ng-container *ngIf="!data.secondaryButtonText">
    <button class="close-btn" mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
    <div class="icon-container" [style.color]="iconColor">
      <mat-icon>{{ icon }}</mat-icon>
    </div>
    <h2 class="title" [style.color]="iconColor">{{ title }}</h2>
    <p class="subtitle" [innerHTML]="data.message"></p>
    <div class="actions">
      <button *ngIf="!isJustOkButton" class="notify-btn" (click)="confirm()">
        {{ data.primaryButtonText || "OK" }}
      </button>
    </div>
  </ng-container>

  <!-- Confirmation dialog: clean simple layout -->
  <ng-container *ngIf="!!data.secondaryButtonText">
    <button class="cd-close" (click)="close()" title="Close">
      <i class="fa-solid fa-xmark"></i>
    </button>
    <div class="cd-body">
      <h2 class="cd-title">{{ title }}</h2>
      <p class="cd-message" [innerHTML]="data.message"></p>
    </div>
    <div class="cd-footer">
      <button class="cd-btn cd-btn--cancel" (click)="close()">
        {{ data.secondaryButtonText }}
      </button>
      <button class="cd-btn cd-btn--confirm" (click)="confirm()">
        {{ data.primaryButtonText || "Confirm" }}
      </button>
    </div>
  </ng-container>

</div>

